
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

interface ScoreHistoryProps {
  chartData: Array<{
    date: string;
    score: number;
  }>;
}

export const ScoreHistory = ({ chartData }: ScoreHistoryProps) => {
  // Process data to show only every nth point if there are many tests
  const processedData = chartData.length > 7 
    ? chartData.filter((_, index) => index % Math.ceil(chartData.length / 7) === 0)
    : chartData;

  // Add the most recent test result if it's not already included
  if (chartData.length > 0 && processedData[processedData.length - 1] !== chartData[chartData.length - 1]) {
    processedData.push(chartData[chartData.length - 1]);
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Score History</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart 
              data={processedData} 
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
              <XAxis 
                dataKey="date" 
                className="text-xs"
                tick={{ fill: 'currentColor' }}
                tickFormatter={(value) => {
                  const date = new Date(value);
                  return date.toLocaleDateString('en-US', { 
                    month: 'short',
                    day: 'numeric'
                  });
                }}
                interval="preserveStartEnd"
              />
              <YAxis 
                domain={[0, 100]} 
                className="text-xs"
                tick={{ fill: 'currentColor' }}
                tickFormatter={(value) => `${value}%`}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: 'white',
                  border: '1px solid #e2e8f0',
                  borderRadius: '0.5rem',
                  padding: '0.5rem',
                }}
                formatter={(value: number) => [`${value}%`, 'Score']}
                labelFormatter={(label) => {
                  const date = new Date(label);
                  return date.toLocaleDateString('en-US', { 
                    month: 'long', 
                    day: 'numeric',
                    year: 'numeric'
                  });
                }}
              />
              <Line
                type="monotone"
                dataKey="score"
                stroke="hsl(var(--primary))"
                strokeWidth={2}
                dot={{ fill: "hsl(var(--primary))", r: 4 }}
                activeDot={{ r: 8 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
